/*******************************************************************************
* Copyright     : Copyright (c)  2019 Honeywell Inc. All rights reserved.
*                 This work contains trade secrets and confidential materials
*                 of Honeywell Inc., and its use or disclosure in whole or in
*                 part without express written permission of Honeywell Inc.
*                 is prohibited.
*
* Name          : cart-details-actions.ts
*
* Project Title : Checkout
*
* Description   : Initial version
*
* Company       : Honeywell Technology Solutions , Hyderabad
*
* @Author       : H352615
*
* @Date         : AUG 2, 2019
*
* @Version      : Version 1.0
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : modified the action classes with response structure of get cart details service(ASDS-909)
 *
 *
 * By            : H352615
 * On            : Aug 16, 2019
 * Description   : Integrated Cart view response structure with ASDS-909
* By            : Avanthi G (E860178)
* On            : Sep 06, 2019
* Description   : Sending Dymanic UserID for fetching mycart details service and add to cart service(ASDS-1173)
 *
 * By            : Sivateja (H267743)
 * On            : Aug 14, 2019
 * Description   : add dispatch to load cart details in store (ASDS-1048)
 *
 * By            : Deepthi B (E844276)
 * On            : Sep 23, 2019
 * Description   : Added the code to delete aspire product - ASDS-413
 * By            : H224423
 * On            : Sep 25, 2019
 * Description   : ASDS-411 Edit cart Item Aspire changes
 * By            : H224423
 * On            : Sep 27, 2019
 * Description   : ASDS-1287 - Cart Popup Alignment, Font, Icon
 *
 * By            : H224423
 * On            : Oct 11, 2019
 * Description   : ASDS-1478 cart icon reset evertime on cart icon hover issue fix.
 *
 * By            : Madhu Gali - H175591
 * On            : 18 Oct 2019
 * Description   : ASDS-1549
 *
 * By            : Deepthi Bachu - E844276
 * On            : 24 Oct 2019
 * Description   : ASDS-115
 *
 * By            : E807238
 * On            : Nov 1, 2019
 * Description   : ASDS-1693: Unable to delete product in cart
 *
 * By            : E807238
 * On            : Nov 13, 2019
 * Description   : ASDS-1832: APU Non MSA Product Price display in Flyout
 *
 * By            : Deepthi Bachu - E844276
 * On            : 15 Nov, 2019
 * Description   : ASDS-1808
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1953
 *
 * By            : SandeepRaja
 * On            : Dec 03, 2019
 * Description   : ASDS-1951: Change Account-Delete APU MSA from Cart
 *
 * By            : Madhu Gali - H175591
 * On            : Dec 05, 2019
 * Description   : ASDS-2018
 *
 * By            : Deepthi Bachu - E844276
 * On            : 28 Nov, 2019
 * Description   : ASDS-1961 - Product price in Flyout is coming as zero
 *
 * By            	: Madhu Gali
 * On            	:  Dec 18, 2019
 * Description      : ASDS-584
 *
 * By            : H224423
 * On            : Feb 17, 2019
 * Description   : ASDS-2055 => ASDS-2346 issue fixes. Removed getSelectedCartList resetting before API call.
 *
 * By            : H224423
 * On            : Feb 26, 2019
 * Description   : ASDS-2349 - APU Product Features API Integration changes
 *
 * By            : Deepthi Bachu(E844276)
 * On            : Mar 13, 2020
 * Description   : ASDS-2414 - APU MSA - acknowledge after deleting product from cart for address change
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : Apr 03 2020
 * Description   : ASDS-2190 - API error handling changes
 *
 * By            : H224423
 * On            : 09 Apr, 2020
 * Description   : ASDS-2497 APU SIT Fixes.
 *
 * By            : Srinivas Grandhi (E528634)
 * On            : Apr 06,2020
 * Description   : updated code as per ASDS-2432.
 *
 * By            : H422336
 * On            : Oct 9, 2020
 * Description   : ASDS - 3259 UI Enhancements for Phase - II
 *
 * By            : H422337
 * On            : Oct 09, 2020
 * Description   : ASDS - 3260 UI Enhancements for Phase - II
 *
 * By            : H422336
 * On            : Oct 13, 2020
 * Description   : ASDS - 3262, ASDS-3263 UI Enhancements for Phase - II
 *
 * By            : H422337
* On            : Oct 13, 2020
* Description   : ASDS - 3626 UI Enhancements for Phase - II
*
* By             : H422337
* On             : Oct 14,2020
* Description    : ASDS-3566 APU enhancements as part of phase-2
*
* By            : H422336
* On            : Oct, 16 2020
* Description   : ASDS-3268 UI Enhancements for Phase-II
*
* By            : H422337
* On            : Oct 15, 2020
* Description   : ASDS-3558 UI Enhancements for phase-2
*
* By             : H422336
* On             : Oct 22,2020
* Description    : ASDS-3783 APU Enhancements Phase-II Bugfix
*
* By            : H422336
* On            : Oct, 22 2020
* Description   : ASDS-3535 UI Enhancements for Phase-II
*
* By            : H422337
* On            : Oct 27, 2020
* Description   : ASDS-3552 - UI Enhancements for Phase - II Forge API changes
*
* By            : H422337
* On            : Oct 27, 2020
* Description   : ASDS-3555 - UI Enhancements for Phase - II -migrate to Forge API
*
* By            : H422337
* On            : Nov 01, 2020
* Description   : ASDS-3265 Enhancements of phase-2 - Purchase Order Quantity validation & MSA products delete toast message chanages
*
* By            : H422337
* On            : Nov 04, 2020
* Description   : ASDS-3570 - UI Enhancements for Phase - II  with Forge API changes
*
* By            : H422337
* On            : Nov 04, 2020
* Description   : ASDS-3572,ASDS-3573 Enhancements of phase-2 - Edit Aspire product changes
*
* By            : H422337
 * On            : Nov, 19 2020
 * Description   : ASDS-4083 UI Enhancements for Phase-II  bug fix & Delete All  products from the cart

******************************************************************************/

import Action from "./Action";
import { AsdsReduxAction, AbstractCartView } from "../../../../../types";
import ActionConstants from "../action-constants";
import CartDetailsAPI from "../../API/cart-detials-api";
import ConfigureProductActions from "./configure-product-actions";
import OrderSummaryActions from "./order-summary-actions";
import { logInfo, logError } from "../../../../utils/console-utility";
import CheckoutConstants from "modules/checkout/constants/checkout-constants";
import ConfigureAPUActions from "./configure-apu-actions";
import ConfigureWirelessActions from "./configure-wireless-actions";
import PlaceOrderRequestActions from "./place-order-request-actions";
import ConfigureAPUAPI from "modules/checkout/API/configureAPUAPI";

/**
 * A mapper class for mapping response to component understandable structure.
 */
class CartDetailsMapper {
  static mapCartListToAbstractCartView(
    cartListResponse: CartListAPIResponse
  ): AbstractCartView {
    let totalAmount = 0;
    let cartList;
    if (cartListResponse.result.cart) {
      cartList = cartListResponse.result.cart.products.map((product) => {
        let price = 0;
        let quantity = 0;
        // Aspire product price details
        if (
          CheckoutConstants.ASPIRE_CATEGORY_NAME.toUpperCase() ===
          product.categoryName.toUpperCase()
        ) {
          price = product.aspire.reduce((a, b) => a + b.unitPrice, 0);
          quantity += product.aspire.length;
        } else if (
          CheckoutConstants.APU_CATEGORY_NAME.toUpperCase() ===
          product.categoryName.toUpperCase()
        ) {
          // APU product price details
          if (product.customerType.msa) {
            price += product.customerType.apuMsaSerials.reduce(
              (a, b) => a + b.unitPrice,
              0
            );
            quantity += product.customerType.apuMsaSerials.length;
          } else {
            price += product.customerType.apuNonMsaSerials.reduce(
              (a, b) => a + b.unitPrice,
              0
            );
            quantity += product.customerType.apuNonMsaSerials.length;
          }
        } else {
          // wireless product price details
          price = product.wireless.reduce((a, b) => a + b.unitPrice, 0);
          quantity += product.wireless.length;
        }
        totalAmount += price;
        return {
          productName: product.prodName,
          amount: price + "", // type is string.
          // attributeName: product.attributeName,
          // classNameApplicable: product.classNameApplicable,
          // iconApplicable: product.iconApplicable,
          id: product.id,
          quantity: quantity,
          productId: product.prodId,
        };
      });

      return {
        cartList,
        amount: {
          subtotal: cartListResponse.result.cart?.grandTotalPrice + "",
        },
      };
    } else {
      return { cartList: [], amount: { subtotal: totalAmount + "" } };
    }
  }

  static mapCartListToSelectedCartList(results: any) {
    let cartAmount = 0;
    return {
      results: results.cart.products.map((eachProduct) => {
        const cartList: any = [];
        let totalPrice = 0;
        let seq;
        if (
          eachProduct.categoryName.toUpperCase() ===
          CheckoutConstants.APU_CATEGORY_NAME.toUpperCase()
        ) {
          if (eachProduct.customerType.msa) {
            eachProduct.customerType.apuMsaSerials.forEach(
              (apuLineItemDetail) => {
                apuLineItemDetail.expiryDate = new Date(
                  apuLineItemDetail.expiryDate
                ).toLocaleDateString();
                totalPrice = eachProduct.totalPrice;
                cartList.push({ ...apuLineItemDetail });
              }
            );
          } else {
            eachProduct.customerType.apuNonMsaSerials.forEach(
              (apuLineItemDetail) => {
                totalPrice = eachProduct.totalPrice;
                cartList.push({ ...apuLineItemDetail });
              }
            );
          }
          cartAmount += totalPrice;
        } else if (
          eachProduct.categoryName.toUpperCase() ===
            CheckoutConstants.DLMUW_CATEGORY_NAME.toUpperCase() ||
          eachProduct.categoryName.toUpperCase() ===
            CheckoutConstants.OTHERS_CATEGORY_NAME.toUpperCase()
        ) {
          eachProduct.wireless.forEach((wirelessLineItemDetail) => {
            totalPrice += wirelessLineItemDetail.unitPrice;
            cartList.push({ ...wirelessLineItemDetail });
          });
          cartAmount += totalPrice;
        } else if (
          eachProduct.categoryName.toUpperCase() ===
          CheckoutConstants.ASPIRE_CATEGORY_NAME.toUpperCase()
        ) {
          eachProduct.aspire.forEach((subProd) => {
            totalPrice += subProd.unitPrice;
            cartList.push({ ...subProd });
          });
          seq = results.cart.seq;
          cartAmount += totalPrice;
        }
        return {
          ...eachProduct,
          cartList,
          totalPrice,
          length: cartList.length,
          seq,
        };
      }),
      cartAmount,
    };
  }

  /**
   * Method to map apu product details
   * @param newFeatureList
   */
  static cartToWirelessProductListMappper(wirelessData: any) {
    // mapping features
    let productData: any = [];

    wirelessData.forEach((feature) => {
      productData.push({
        aircraftType: feature.aircraftType,
        serialNumber: feature.aircraftSerialNum,
        tailNumber: feature.aircraftTailNo,
        price: feature.unitPrice,
      });
    });

    return productData;
  }

  /**
   * Method to map apu product details
   * @param newFeatureList
   */
  static cartToAPUProductListMappper(apuData: any) {
    // mapping features
    let productData: any = [];
    let i: number;

    if (apuData.msa) {
      for (i = 0; i < apuData.apuMsaSerials.length; i++) {
        productData.push({
          soldTo: apuData.apuMsaSerials[i].soldTo,
          contractNo: apuData.apuMsaSerials[i].distributionNo,
          expirationDate: apuData.apuMsaSerials[i].expiryDate,
          aircraftOem: apuData.apuMsaSerials[i].model,
          serialNumber: apuData.apuMsaSerials[i].serialNo,
          unitPrice: apuData.apuMsaSerials[i].unitPrice,
          subProductId: apuData.apuMsaSerials[i].subProductId,
        });
      }
    } else {
      for (i = 0; i < apuData.apuNonMsaSerials.length; i++) {
        if (
          apuData.apuNonMsaSerials[i].subProductDesc ===
          CheckoutConstants.NON_MSA_PURCHASE_ORDER
        ) {
          productData.push({
            acOem: apuData.apuNonMsaSerials[i].model,
            serialNumber: apuData.apuNonMsaSerials[i].serialNo,
            purchaseOrderNumber: apuData.apuNonMsaSerials[i].distributionNo,
            unitPrice: apuData.apuNonMsaSerials[i].unitPrice,
            subProductId: apuData.apuNonMsaSerials[i].subProductId,
            subProductDesc: apuData.apuNonMsaSerials[i].subProductDesc,
          });
        } else if (
          apuData.apuNonMsaSerials[i].subProductDesc ===
          CheckoutConstants.NON_MSA_SERVICE_ORDER
        ) {
          productData.push({
            acOem: apuData.apuNonMsaSerials[i].model,
            serialNumber: apuData.apuNonMsaSerials[i].serialNo,
            serviceOrderNumber: apuData.apuNonMsaSerials[i].distributionNo,
            unitPrice: apuData.apuNonMsaSerials[i].unitPrice,
            subProductId: apuData.apuNonMsaSerials[i].subProductId,
            subProductDesc: apuData.apuNonMsaSerials[i].subProductDesc,
          });
        } else {
          productData.push({
            acOem: apuData.apuNonMsaSerials[i].model,
            serialNumber: apuData.apuNonMsaSerials[i].serialNo,
            unitPrice: apuData.apuNonMsaSerials[i].unitPrice,
            subProductId: apuData.apuNonMsaSerials[i].subProductId,
            subProductDesc: apuData.apuNonMsaSerials[i].subProductDesc,
            optionId: apuData.apuNonMsaSerials[i].optionId,
            term: apuData.apuNonMsaSerials[i].term,
            optionAvailable: apuData.apuNonMsaSerials[i].optionAvailable,
            optionName: isNaN(apuData.apuNonMsaSerials[i].term)
              ? apuData.apuNonMsaSerials[i].term
              : `Key for ${apuData.apuNonMsaSerials[i].term} Years`,
          });
        }
      }
    }

    return productData;
  }

  /**
   * Method to map product feature details
   * @param newFeatureList
   */
  static cartToProductListMappper(newFeatureList: any) {
    // mapping features
    let productFeaturesDetails: any = [];
    let uniqueData = [] as any;
    newFeatureList.forEach((feature) => {
      if (uniqueData.indexOf(feature.featureName) === -1) {
        productFeaturesDetails.push({
          subProductName: feature.featureName,
          subProductId: feature.featureId,
          subProductDesc: feature.featureDesc,
          unitPrice: feature.unitPrice.toFixed(2),
          validity: feature.validity,
          partNumber: feature.partNumber,
          seq: feature.seq,
          productSeq: feature.prodSeq,
        });
        uniqueData.push(feature.featureName);
      }
    });
    return productFeaturesDetails;
  }

  /**
   * Method to map serial details
   * @param serialList
   */
  static cartSerialToProductSerialMapper(newFeatureList: any) {
    let serialNumberList: any = [];
    let uniqueData: any = [];
    newFeatureList.forEach((feature) => {
      if (uniqueData.indexOf(feature.serialNo) === -1) {
        serialNumberList.push({ serialNumber: feature.serialNo, error: "" });
        uniqueData.push(feature.serialNo);
      }
    });
    return serialNumberList;
  }
}

class CartDetailsActions extends Action {
  /**
   * Fetches the latest updated cart count. Without intialisting cartlist to empty array.
   * @param userId
   * ASDS-1478 cart icon reset evertime on cart icon hover issue fix.
   */
  static getAbstractCartViewWithoutReset(userId: string) {
    return async (dispatch, getState) => {
      const soldTo =
        getState().selectAccount?.selectAccountDetails?.payload?.soldTo
          ?.sapNumber;
      if (!soldTo) {
        dispatch(CartDetailsActions.setAbstractCartViewError());
        return; // Exit the function early.
      }
      const response = await CartDetailsAPI.getCartData(userId, soldTo);
      if (response && response.result && response.result.cart) {
        dispatch(
          CartDetailsActions.setAbstractCartView(
            CartDetailsMapper.mapCartListToAbstractCartView(response)
          )
        );
        dispatch(ConfigureProductActions.setProductsInCart(response));
        dispatch(ConfigureAPUActions.setProductsInCart(response));
        dispatch(ConfigureWirelessActions.setProductsInCart(response));
      } else if (response && response.result) {
        dispatch(CartDetailsActions.getAbstractCartViewInitiated());
        dispatch(
          CartDetailsActions.setAbstractCartView({
            cartList: [],
            amount: { subtotal: "" },
          })
        );
      } else {
        dispatch(CartDetailsActions.setAbstractCartViewError());
      }
    };
  }

  static setAbstractCartView(cartDetails: AbstractCartView): AsdsReduxAction {
    return {
      type: ActionConstants.SET_ABSTRACT_CART_VIEW,
      payload: {
        cartDetails,
        isFetching: false,
        isSuccess: true,
      },
    };
  }

  /**
   * @description Method to set API failure (isSuccess parameter)
   */
  static setAbstractCartViewError(): AsdsReduxAction {
    return {
      type: ActionConstants.SET_ABSTRACT_CART_VIEW,
      payload: {
        cartDetails: {},
        isFetching: false,
        isSuccess: false,
      },
    };
  }

  static getCartData(userId: string, view: string) {
    return async (dispatch, getState) => {
      if (view === "abstract" || view === "both") {
        dispatch(CartDetailsActions.getAbstractCartViewInitiated());
      }
      //
      const soldTo =
        getState().selectAccount?.selectAccountDetails?.payload?.soldTo
          ?.sapNumber;

      if (!soldTo) {
        // Dispatch an error or handle the missing data scenario
        dispatch(CartDetailsActions.setAbstractCartViewError());
        return; // Exit the function early as necessary data is missing
      }
      // const response = await CartDetailsAPI.getCartData(userId, soldTo).catch(error => {
      //     logError('Error in fetching cart list', error);
      //     if (view === 'selectedcart' || view === 'both') {
      //         dispatch({
      //             type: ActionConstants.SET_SELECTED_CART_LIST,
      //             payload: {data: [], totalAmount: 0, isFetching: false, isSuccess: false},
      //         });
      //     }
      //     if (view === 'abstract' || view === 'both'){
      //         dispatch(CartDetailsActions.setAbstractCartViewError());
      //     }
      // });

      let response;
      try {
        response = await CartDetailsAPI.getCartData(userId, soldTo);
      } catch (error) {
        logError("Error in fetching cart list", error);
        if (view === "selectedcart" || view === "both") {
          dispatch({
            type: ActionConstants.SET_SELECTED_CART_LIST,
            payload: {
              data: [],
              totalAmount: 0,
              isFetching: false,
              isSuccess: false,
            },
          });
        }
        if (view === "abstract" || view === "both") {
          dispatch(CartDetailsActions.setAbstractCartViewError());
        }
        return;
      }

      if (response && response.result && response.result.cart) {
        if (
          getState().cartDetails.hasPriceChanged !==
          response.result.priceChanged
        ) {
          dispatch({
            type: ActionConstants.SET_TOASTER,
            payload: {
              notify: "top-right",
            },
          });
          dispatch(
            CartDetailsActions.checkForPriceChange(response.result.priceChanged)
          );
        }
        if (getState().cartDetails.isCheckedQuantityInCart) {
          dispatch(
            CartDetailsActions.deleteExpiredNonMSAPOProducts(
              response.result.cart.products
            )
          );
        }
        if (view === "selectedcart" || view === "both") {
          // get selected cart list
          const selectedCartList =
            CartDetailsMapper.mapCartListToSelectedCartList(response.result);
          dispatch({
            type: ActionConstants.SET_SELECTED_CART_LIST,
            payload: {
              data: selectedCartList.results,
              amount: selectedCartList.cartAmount,
              isFetching: false,
              isSuccess: true,
            },
          });
          dispatch(ConfigureProductActions.setProductsInCart(response));
          dispatch(ConfigureAPUActions.setProductsInCart(response));
          dispatch(ConfigureWirelessActions.setProductsInCart(response));
        }
        if (view === "abstract" || view === "both") {
          // Abstract cart view
          dispatch(
            CartDetailsActions.setAbstractCartView(
              CartDetailsMapper.mapCartListToAbstractCartView(response)
            )
          );
          dispatch(ConfigureProductActions.setProductsInCart(response));
          dispatch(ConfigureAPUActions.setProductsInCart(response));
          dispatch(ConfigureWirelessActions.setProductsInCart(response));
        }
      } else if (response && response.result) {
        if (view === "selectedcart" || view === "both" || view === "abstract") {
          dispatch(
            CartDetailsActions.setAbstractCartView({
              cartList: [],
              amount: { subtotal: "" },
            })
          );
          dispatch(
            ConfigureProductActions.setProductsInCart({
              result: { cart: { products: [] } },
            })
          );
          dispatch({
            type: ActionConstants.SET_SELECTED_CART_LIST,
            payload: {
              data: [],
              amount: "",
              isFetching: false,
              isSuccess: true,
            },
          });
        }
      } else if (view === "abstract" || view === "both") {
        dispatch(CartDetailsActions.setAbstractCartViewError());
      }
    };
  }

  static showErrorOndeleteProduct(prodName, error = "") {
    logError("Error while deleting product from cart: ", error);
    return (dispatch) => {
      dispatch({
        type: ActionConstants.SHOW_ERROR_ON_DELETE_PROD,
        payload: {
          lastDeleteProdName: prodName,
        },
      });
    };
  }

  static checkForPriceChange(value: boolean) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.CHECK_FOR_PRICE_CHANGE,
        payload: {
          hasPriceChanged: value,
        },
      });
    };
  }

  static hideErrorOndeleteProduct(prodName = "") {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.HIDE_ERROR_ON_DELETE_PROD,
        payload: {
          lastDeleteProdName: prodName,
        },
      });
    };
  }

  static showErrorOnEditProduct(prodName: string) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.SET_ERROR_ON_EDIT_PROD,
        payload: {
          errorOnEdit: true,
          lastEditProdName: prodName,
        },
      });
    };
  }

  static hideErrorOnEditProduct() {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.SET_ERROR_ON_EDIT_PROD,
        payload: {
          errorOnEdit: false,
          lastEditProdName: "",
        },
      });
    };
  }

  static showDeleteMsg(value: boolean) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.SHOW_DELETE_MSG,
        payload: {
          showDeleteMsgFlag: value,
        },
      });
    };
  }

  static checkDeleteProductSuccess(value: boolean) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.CHECK_DELETE_PRODUCT_SUCCESS,
        payload: {
          isProductDeleted: value,
        },
      });
    };
  }

  static toggleDeletePopUp(value: boolean, product: any) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.TOGGLE_DELETE_POPUP,
        payload: {
          showDeletePopUp: value,
          product,
        },
      });
    };
  }

  static toggleCartIcon(value: boolean) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.OPEN_CART_ICON,
        payload: {
          openCartIcon: value,
        },
      });
    };
  }

  static deleteAllMsaProducts(currentSoldToSAP) {
    return async (dispatch, getState) => {
      const userID =
        getState().userValidationData.payload.userInfo.customer_sub;
      await dispatch(
        // get cart products
        CartDetailsActions.getCartData(userID, "selectedcart")
      );
      const selectedCartList = getState().cartDetails.selectedCartList.cartList;
      if (selectedCartList) {
        selectedCartList.forEach((prodInCart) => {
          if (
            prodInCart.categoryName.toLowerCase() ===
              CheckoutConstants.APU_CATEGORY_NAME &&
            prodInCart.customerType.msa
          ) {
            let changeInSoldTo = false;
            // prodInCart.apuProductConfig.apuLineItemDetail.forEach(apuLineItem => {
            prodInCart.cartList.forEach((apuLineItem) => {
              if (apuLineItem.soldTo !== currentSoldToSAP) {
                changeInSoldTo = true;
              }
            });

            if (changeInSoldTo) {
              logInfo("Deleting APU MSA products for User: ", userID);
              CartDetailsAPI.deleteProduct(
                userID,
                prodInCart.cartSeq,
                prodInCart.customerType.prodSeq
              ).then((response) => {
                if (response === "SUCCESS") {
                  dispatch(
                    CartDetailsActions.updatedeleteAllProductsSuccessFlag(true)
                  );
                  dispatch(CartDetailsActions.getCartData(userID, "abstract"));
                }
              });

              dispatch({
                type: ActionConstants.SET_TOASTER,
                payload: {
                  notify: "top-right",
                },
              });
            }
          }
        });
      }
    };
  }
  static deleteExpiredNonMSAPOProducts(selectedCartList: any) {
    return async (dispatch, getState) => {
      dispatch({
        type: ActionConstants.CHECK_FOR_PO_QUANTITY_IN_CART,
        payload: {
          isCheckedQuantityInCart: false,
        },
      });
      // const soldTo = getState().selectAccount.selectAccountDetails.payload.soldTo.sapNumber;
      const soldTo =
        getState().selectAccount?.selectAccountDetails?.payload?.soldTo
          ?.sapNumber;

      if (!soldTo) {
        // Dispatch an error or handle the missing data scenario
        dispatch(CartDetailsActions.setAbstractCartViewError());
        return; // Exit the function early as necessary data is missing
      }
      const userID =
        getState().userValidationData.payload.userInfo.customer_sub;

      if (selectedCartList) {
        selectedCartList.map((product) => {
          let customerPurchaseOrderInCart: any = [];
          if (
            product.categoryName.toLowerCase() ===
              CheckoutConstants.APU_CATEGORY_NAME &&
            product.customerType.apuNonMsaSerials &&
            product.customerType.apuNonMsaSerials.length > 0
          ) {
            product.customerType.apuNonMsaSerials.map((apuNonMsaProduct) => {
              if (
                apuNonMsaProduct.subProductDesc ===
                CheckoutConstants.NON_MSA_PURCHASE_ORDER
              ) {
                customerPurchaseOrderInCart.push(apuNonMsaProduct);
              }
            });
          }
          if (
            customerPurchaseOrderInCart &&
            customerPurchaseOrderInCart.length > 0
          ) {
            ConfigureAPUAPI.getPurchaseOrderDetails(soldTo).then((response) => {
              const purchaseOrderNumbers =
                response.data &&
                response.data.purchaseOrders &&
                response.data.purchaseOrders.distributions;
              let countAdded: number = 0;
              if (purchaseOrderNumbers) {
                purchaseOrderNumbers.map((purchaseOrderNumber) => {
                  countAdded = 0;
                  customerPurchaseOrderInCart.map((purchaseOrder) => {
                    if (
                      purchaseOrderNumber.distributionNo ===
                      purchaseOrder.distributionNo
                    ) {
                      countAdded++;
                      if (
                        parseInt(purchaseOrderNumber.remainingQuantity) === 0 ||
                        parseInt(purchaseOrderNumber.remainingQuantity) <
                          countAdded
                      ) {
                        CartDetailsAPI.deleteProduct(
                          userID,
                          product.cartSeq,
                          product.customerType?.prodSeq
                        ).then((deleteResponse) => {
                          if (deleteResponse === "SUCCESS") {
                            dispatch(
                              CartDetailsActions.getCartData(userID, "abstract")
                            );
                          }
                        });
                        dispatch(
                          CartDetailsActions.updateDeleteNonMSAPOSuccessFlag(
                            true
                          )
                        );
                        dispatch({
                          type: ActionConstants.SET_TOASTER,
                          payload: {
                            notify: "top-right",
                          },
                        });
                      }
                    }
                  });
                });
              }
            });
          }
        });
      }
    };
  }

  static deleteDlmuwProducts() {
    return async (dispatch, getState) => {
      const userID =
        getState().userValidationData.payload.userInfo.customer_sub;
      await dispatch(
        // get cart products
        CartDetailsActions.getCartData(userID, "selectedcart")
      );
      const selectedCartList = getState().cartDetails.selectedCartList.cartList;
      if (selectedCartList) {
        selectedCartList.forEach((prodInCart) => {
          if (
            prodInCart.prodName
              .toLowerCase()
              .includes(CheckoutConstants.DLMUW_PRODUCT_NAME)
          ) {
            logInfo("Deleting DLMU-W products for User: ", userID);
            dispatch(CartDetailsActions.deleteProduct(prodInCart));
          }
        });
      }
    };
  }

  static deleteAllProductsFromCart() {
    return async (dispatch, getState) => {
      const userID =
        getState().userValidationData.payload.userInfo.customer_sub;
      await dispatch(
        // get cart products
        CartDetailsActions.getCartData(userID, "selectedcart")
      );
      const selectedCartList = getState().cartDetails.selectedCartList.cartList;
      if (selectedCartList.length !== 0) {
        logInfo("Deleting all products in cart for the User: ", userID);

        dispatch({
          type: ActionConstants.SET_TOASTER,
          payload: {
            notify: "top-right",
          },
        });
        CartDetailsAPI.deleteAllProduct(userID)
          .then((response) => {
            if (response === "SUCCESS") {
              dispatch(
                CartDetailsActions.updatedeleteAllProductsSuccessFlag(true)
              );
              dispatch(
                // get cart products & updates cart count
                CartDetailsActions.getCartData(userID, "both")
              );
              dispatch(
                // updates order summary
                OrderSummaryActions.getOrderSummary(userID)
              );
            } else {
              dispatch(
                CartDetailsActions.showErrorOndeleteProduct("all products")
              );
            }
          })
          .catch((error) => {
            dispatch(
              CartDetailsActions.showErrorOndeleteProduct("all products", error)
            );
          });
      }
    };
  }

  static deleteProduct(product) {
    return (dispatch, getState) => {
      const userId =
        getState().userValidationData.payload.userInfo.customer_sub;
      const productInCart = getState().configAPUData.payload.productsInCart;
      // const getDeleteProductInCart = productInCart?.filter(
      //   (incart) => incart?.id === product?.id
      // );
      const getDeleteProductInCart = Array.isArray(productInCart) ? productInCart.filter(
        (incart) => incart?.id === product?.id
      ) : [];
      
      // const cartSeq = getDeleteProductInCart[0]?.cartSeq;
      // let prodSeq = 0;
      // if (
      //   getDeleteProductInCart[0]?.categoryName?.toLowerCase() ===
      //   CheckoutConstants.APU_CATEGORY_NAME
      // ) {
      //   prodSeq = getDeleteProductInCart[0]?.customerType?.prodSeq;
      // } else if (
      //   getDeleteProductInCart[0]?.categoryName?.toLowerCase() ===
      //   CheckoutConstants.DLMUW_CATEGORY_NAME
      // ) {
      //   prodSeq = getDeleteProductInCart[0]?.wireless[0]?.prodSeq;
      // }

      const cartSeq =
        getDeleteProductInCart.length > 0
          ? getDeleteProductInCart[0].cartSeq
          : undefined;
      let prodSeq = 0;
      if (
        getDeleteProductInCart.length > 0 &&
        getDeleteProductInCart[0].categoryName?.toLowerCase() ===
          CheckoutConstants.APU_CATEGORY_NAME
      ) {
        prodSeq = getDeleteProductInCart[0].customerType?.prodSeq;
      } else if (
        getDeleteProductInCart.length > 0 &&
        getDeleteProductInCart[0].categoryName?.toLowerCase() ===
          CheckoutConstants.DLMUW_CATEGORY_NAME
      ) {
        prodSeq = getDeleteProductInCart[0].wireless?.[0]?.prodSeq;
      }

      dispatch({
        type: ActionConstants.SET_TOASTER,
        payload: {
          notify: "bottom-right",
        },
      });

      CartDetailsAPI.deleteProduct(userId, cartSeq, prodSeq)
        .then((response) => {
          if (response === "SUCCESS") {
            dispatch(
              // get cart products & updates cart count
              CartDetailsActions.getCartData(userId, "both")
            );
            dispatch(
              // updates order summary
              OrderSummaryActions.getOrderSummary(userId)
            );
            dispatch(CartDetailsActions.checkDeleteProductSuccess(true));
            dispatch(CartDetailsActions.showDeleteMsg(true));
            dispatch(PlaceOrderRequestActions.resetShippingBillingData());
          } else {
            logInfo(
              "There is some error in processing your request. Please try again after sometime."
            );
            dispatch(CartDetailsActions.checkDeleteProductSuccess(false));
            dispatch(CartDetailsActions.showDeleteMsg(true));
          }
        })
        .catch((error) => {
          logInfo(error);
          dispatch(CartDetailsActions.checkDeleteProductSuccess(false));
          dispatch(CartDetailsActions.showDeleteMsg(true));
        });
    };
  }

  /**
   * Displays Edit model window using Configure Product Component
   * @param product
   */
  static showEditModel(product: any) {
    return (dispatch) => {
      dispatch(CartDetailsActions.hideErrorOnEditProduct());
      dispatch({
        type: ActionConstants.SHOW_EDIT_MODEL,
        payload: {
          product,
        },
      });
      dispatch({
        type: ActionConstants.PRESET_CONFIGURE_PRODUCT_MYCART,
        payload: {
          product,
          productFeatures: CartDetailsMapper.cartToProductListMappper(
            product.aspire
          ),
          serialNumbers: CartDetailsMapper.cartSerialToProductSerialMapper(
            product.aspire
          ),
        },
      });
    };
  }

  /**
   * Displays Edit model window using Configure APU Component
   * @param product
   */
  static showEditModelAPU(product: any) {
    return (dispatch) => {
      dispatch(CartDetailsActions.hideErrorOnEditProduct());
      dispatch({
        type: ActionConstants.SHOW_EDIT_MODEL_APU,
        payload: {
          product,
        },
      });
      dispatch({
        type: ActionConstants.PRESET_CONFIGURE_APU_MYCART,
        payload: {
          product,
          productData: CartDetailsMapper.cartToAPUProductListMappper(
            product.customerType
          ),
        },
      });
    };
  }

  static updatedeleteAllProductsSuccessFlag(flag) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.MSA_SUCCESS_FLAG,
        payload: {
          flag: flag,
        },
      });
    };
  }
  static updateDeleteNonMSAPOSuccessFlag(flag) {
    return (dispatch) => {
      dispatch({
        type: ActionConstants.NON_MSA_PO_SUCCESS_FLAG,
        payload: {
          flag: flag,
        },
      });
    };
  }

  /**
   * Displays Edit model window using Configure Wireless Component
   * @param product
   */
  static showEditModelWireless(product: any) {
    return (dispatch) => {
      dispatch(CartDetailsActions.hideErrorOnEditProduct());
      dispatch({
        type: ActionConstants.SHOW_EDIT_MODEL_WIRELESS,
        payload: {
          product,
        },
      });
      dispatch({
        type: ActionConstants.PRESET_CONFIGURE_WIRELESS_MYCART,
        payload: {
          product,
          productData: CartDetailsMapper.cartToWirelessProductListMappper(
            product.wireless
          ),
        },
      });
    };
  }

  private static getAbstractCartViewInitiated() {
    return {
      type: ActionConstants.GET_ABSTRACT_CART_VIEW,
      payload: {
        isFetching: true,
        isSuccess: false,
        cartDetails: {
          cartList: [],
        },
      },
    };
  }
}

interface CartListAPIResponse {
  result: {
    priceChanged: boolean;
    cart: {
      seq: number;
      userId: string;
      grandTotalPrice?: number;
      product: {
        id: number;
        cartSeq: number;
        wireless: [];
        aspire: [];
      };
      products: [
        {
          id: number;
          cartSeq: number;
          prodId: string;
          prodName: string;
          prodDesc: string;
          system: string;
          categoryName: string;
          totalPrice: number;
          customerType: {
            seq: number;
            prodSeq: number;
            msa: boolean;
            apuNonMsaSerials: [
              {
                seq: number;
                customerTypeSeq: number;
                subProductId: string;
                soldTo: string;
                model: string;
                distributionNo: string;
                serialNo: string;
                unitPrice: number;
              }
            ];
            apuMsaSerials: [
              {
                unitPrice: number;
              }
            ];
          };
          wireless: [
            {
              unitPrice: number;
            }
          ];
          aspire: [
            {
              unitPrice: number;
            }
          ];
          subProducts: {
            subProductName: string;
            unitPrice: number;
          }[];
        }
      ];
    };
  };
}

export default CartDetailsActions;
